import { collection, doc, getDoc, getDocs, query, runTransaction, serverTimestamp, setDoc, where } from 'firebase/firestore';
import { db } from '../firebase';
import { SEEDF_COURSE_ID } from '../content/seedf/officialProgram2022';

export async function loadIntegratedObjectives(uid) {
  const snapshot = await getDoc(doc(db, 'integratedPlans', uid));
  return snapshot.exists() ? snapshot.data().courseIds || [] : [];
}
export async function saveIntegratedObjectives(uid, courseIds) {
  if (!courseIds.length || courseIds.some(id=>!['inss',SEEDF_COURSE_ID].includes(id))) throw new Error('Selecione ao menos um objetivo válido.');
  await setDoc(doc(db, 'integratedPlans', uid), { courseIds:[...new Set(courseIds)], updatedAt:serverTimestamp() });
}
export async function loadSharedUnits(courseIds) {
  if (!courseIds.length) return [];
  const snapshot = await getDocs(query(collection(db, 'sharedTheory'), where('courseIds','array-contains-any',courseIds), where('published','==',true)));
  return snapshot.docs.map(d=>({ ...d.data(), id:d.id }));
}
export async function saveSharedUnit(unit, content, summary) {
  if (content.length < 3 || !content.every(p=>typeof p==='string' && p.trim()) || !summary.trim()) throw new Error('Teoria e resumo devem ter conteúdo efetivo.');
  await runTransaction(db, async tx=>{
    const ref=doc(db,'sharedTheory',unit.id); const current=await tx.get(ref);
    // Only theory text is edited here. New versions require a new assessment review.
    tx.set(ref,{ ...unit, content, summary, notebookSummary:[summary,...unit.keyPoints].join('\n'), courseIds:['inss',SEEDF_COURSE_ID], published:true,
      version:Math.max(unit.version,current.exists()?current.data().version:0)+1,
      assessmentStatus:'REVIEW_REQUIRED', updatedAt:serverTimestamp() });
  });
}
export async function loadStudentIntegratedProgress(uid) {
  const snapshot = await getDoc(doc(db,'userProgress',uid));
  return snapshot.exists()?snapshot.data():{};
}
